import { Action, State, StateContext, Store, NgxsOnInit } from '@ngxs/store';

import { Donation, DonationType } from './donation.model';
import * as DonationActions from './donation.actions';
import * as DesignationActions from '../designation/designation.actions';

import { AppSettings } from '../../app.settings';
import { Sdk } from '../../core/sdk.service';

@State<Donation>({
  name: 'donation',
  defaults: new Donation()
})
export class DonationState implements NgxsOnInit {
  constructor(
    private sdk: Sdk,
    private settings: AppSettings,
    private store: Store
  ) {}
  ngxsOnInit(ctx: StateContext<Donation>) {
    let iatsGatewayId: string;
    const enabledTypes = [];

    const defaultMap = {
      creditcards: { text: 'Credit Card', value: DonationType.Credit },
      debitcards: { text: 'Debit Card', value: DonationType.Debit },
      echecks: { text: 'eCheck', value: DonationType.Check },
      paypal: { text: 'PayPal', value: DonationType.PayPal },
      apple_pay: {
        text: '',
        value: DonationType.ApplePay,
        image: 'https://static.idonate.com/images/Apple_Pay_Mark_RGB_041619.svg'
      },
      google_pay: {
        text: '',
        value: DonationType.GooglePay,
        image: 'https://static.idonate.com/images/google-pay-mark_800.svg'
      }
    };

    try {
      iatsGatewayId = (<any>this.settings.getValue('organization')).attributes
        .config.payment.iats_payment_gateway_id;
    } catch (e) {
      console.error('Unable to inspect payment gateway id', e);
      iatsGatewayId = undefined;
    }

    const paymentConfig = {
      ...defaultMap
    };

    if (iatsGatewayId) {
      paymentConfig.echecks.text = 'Chequing';
    }

    // PayPal Checkout always offers Venmo as a funding source; label the
    // tab to match (legacy Spreedly PayPal has no Venmo, so keep 'PayPal').
    const paypalGateway = this.settings.getValue('paypalGateway');
    if (paypalGateway && paypalGateway.backendName === 'paypal_checkout') {
      paymentConfig.paypal.text = 'PayPal or Venmo';
    }

    const types = this.settings.getValue('properties').accepted_types.money;

    for (const type of types) {
      if (type === 'apple_pay') {
        // Show Apple Pay tab only when device supports
        this.sdk.isApplePaySupported().then((isSupported: boolean) => {
          if (isSupported) {
            enabledTypes.push(paymentConfig['apple_pay']);
          }
        });
      } else if (type === 'google_pay') {
        this.sdk.isGooglePaySupported().then(readyToPayResponse => {
          if (readyToPayResponse.result) {
            enabledTypes.push(paymentConfig['google_pay']);
          }
        });
      } else {
        enabledTypes.push(paymentConfig[type]);
      }
    }

    const selected =
      this.settings.getValue('properties').payment_type ||
      enabledTypes[0].value;
    ctx.dispatch(new DonationActions.SetDonationType(selected));
    ctx.dispatch(new DonationActions.SetDonationEnabledTypes(enabledTypes));
  }

  @Action(DonationActions.SetDonationAmount)
  setDonationAmount(
    { getState, setState }: StateContext<Donation>,
    { payload }: DonationActions.SetDonationAmount
  ) {
    getState().amount != payload &&
      setState({ ...getState(), amount: payload });
    this.store.dispatch(new DesignationActions.SetTotal(payload));
  }

  @Action(DonationActions.SetDonationType)
  setDonationType(
    { getState, setState }: StateContext<Donation>,
    { payload }: DonationActions.SetDonationType
  ) {
    setState({ ...getState(), type: payload });
  }

  @Action(DonationActions.SetDonationDouble)
  setDonationDouble(
    { getState, setState }: StateContext<Donation>,
    { payload }: DonationActions.SetDonationDouble
  ) {
    setState({ ...getState(), double: payload });
  }

  @Action(DonationActions.SetDonationEnabledTypes)
  setDonationEnabledTypes(
    { getState, setState }: StateContext<Donation>,
    { payload }: DonationActions.SetDonationEnabledTypes
  ) {
    setState({ ...getState(), enabledTypes: payload });
  }
}
